import Background from '../../../scenes/shared/Background';

export default Background;
